// extracted by mini-css-extract-plugin
export const wrapper = "styles-module--wrapper--oprVw";
export const main = "styles-module--main--14hz8";
export const links = "styles-module--links--y8BUi";
export const left = "styles-module--left--wYr-h";
export const right = "styles-module--right--20x_r";
export const disclaimer = "styles-module--disclaimer--jpeT0";